import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { MODALITY_COLORS, badgeModalities } from './worklistDisplay';
/**
 * Colored modality chip shared by the paid worklist and the Link tier's
 * send-a-case table (see worklistDisplay.ts for the extraction rationale).
 *
 * A study with series of several modalities (a PET/CT) gets one chip per
 * modality from `modalities`; `modality` alone is the study's own, which is
 * whichever object arrived first.
 */
export function ModalityBadge({ modality, modalities, }) {
    const codes = badgeModalities(modality, modalities);
    if (codes.length === 0)
        return _jsx("span", { className: "text-muted-foreground", children: "-" });
    return (_jsx("span", { className: "inline-flex flex-wrap gap-1", children: codes.map((code) => (_jsx("span", { className: cn('rounded px-2 py-0.5 text-xs font-medium', MODALITY_COLORS[code] || 'bg-gray-600 text-white'), children: code }, code))) }));
}
